// DS1.15M
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation, PapiUser } from '@wix/da-papi-types';
import Flex from '@wix/da-ds/pkg/Flex';
import { getDeviationTitle } from '../../DeviationViews/_helpers';
import { DeviationLink } from '../../Duperbrowse';
import UserAvatar from '../Avatar';
import UserLink from '../Link/UserLink';
import BasicUserName from '../BasicUserName';

import s from './UserIdentityLargeMobile.scss';

export interface Props {
  user?: PapiUser;
  deviation?: PapiDeviation;
  className?: string;
}

const UserIdentityLargeMobile: React.FC<Props> = ({ user, deviation, className }) => {
  const { t } = useTranslation();
  const isBoosted = deviation?.boosted;
  return (
    <Flex className={classnames(s['root'], className)} alignItems="center">
      <UserAvatar user={user} className={s['avatar']} size={32} />
      <div className={s['details']}>
        {deviation && (
          <DeviationLink deviation={deviation}>
            <div className={s['title']}>{getDeviationTitle(deviation)}</div>
            <div className={s['user-and-more']}>
              {user && (
                <div className={s['userlink']}>
                  {t('user.identity.by')}
                  <BasicUserName user={user} />
                </div>
              )}
              {user && isBoosted && <div className={s['dot-divider']}>&middot;</div>}
              {isBoosted && <div className={s['boosted']}>{t('common.boosted')}</div>}
            </div>
          </DeviationLink>
        )}

        {
          // We'll render the username as a link if the deviation wasn't provided
          // just to prevent any awkward blank space near the avatar in edge cases
          !deviation && user && <UserLink user={user} />
        }
      </div>
    </Flex>
  );
};
UserIdentityLargeMobile.displayName = 'UserIdentityLargeMobile';

export default UserIdentityLargeMobile;
